<template>
  <v-app>
    <v-main>
      <div v-if="store.accountId !== ''">
        <div v-if="store.initialized">
          <LightningModelPage />
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useSettingsStore } from './store/settings'
import { useGoogleFonts } from './composables/useGoogleFonts'
import LightningModelPage from './components/LightningModelPage.vue'

const store = useSettingsStore()

const { loadFonts, extractUniqueFonts } = useGoogleFonts()
const fontsLoaded = ref(false)
const fontsError = ref<string | null>(null)

onMounted(async () => {
  try {
    // First fetch settings
    if (store.accountId !== '') {
      await store.fetchSettings()
    }

    // Then load fonts only if settings were fetched successfully
    if (store.initialized && store.pageSettings) {
      console.log('Loading fonts for settings:', store.pageSettings)
      const fontsToLoad = extractUniqueFonts(store.settings?.globalSettings)

      if (fontsToLoad.length > 0) {
        await loadFonts(fontsToLoad)
        fontsLoaded.value = true
      }
    }
  } catch (error) {
    fontsError.value =
      error instanceof Error ? error.message : 'Failed to load fonts'
    console.error('Font loading error:', error)
  }
})
</script>
